import { Settings } from '../../type';

const settings = (state: Settings): Settings => state || {};

export default settings;
